import React, { useState, useEffect } from "react";
import { useI18n } from '../context/I18nContext';
import api from "../services/api";
import { RefreshIcon } from "../components/Icons";

const History = () => {
  const { t } = useI18n();
  const [messages, setMessages] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, pages: 0, total: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadMessages(1);
  }, []);

  const loadMessages = async (page) => {
    setLoading(true);
    try {
      const res = await api.get(`/whatsapp/history?page=${page}&limit=20`);
      setMessages(res.data.messages || []);
      setPagination(res.data.pagination || { page: 1, pages: 0, total: 0 });
    } catch (error) {
      console.error(t('history.a1'), error);
    }
    setLoading(false);
  };

  const getStatusBadge = (status) => {
    const styles = {
      sent: "bg-blue-100 text-blue-700",
      delivered: "bg-green-100 text-green-700",
      read: "bg-emerald-100 text-emerald-700",
      failed: "bg-red-100 text-red-700"
    };
    const labels = {
      sent: "Enviada",
      delivered: "Entregue",
      read: "Lida",
      failed: "Falhou"
    };
    return (
      <span className={`px-2.5 py-1 text-xs font-medium rounded-full ${styles[status] || "bg-gray-100 text-gray-700"}`}>
        {labels[status] || status}
      </span>
    );
  };

  return (
    <div className="p-8">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{t('hist.title')}</h1>
          <p className="text-gray-500 mt-1">{t('hist.totalMessages', { v1: pagination.total })}</p>
        </div>
        <button
          onClick={() => loadMessages(pagination.page)}
          className="flex items-center gap-2 px-4 py-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <RefreshIcon className="w-5 h-5" />
          <span className="text-sm font-medium">{t('hist.refresh')}</span>
        </button>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        {loading ? (
          <div className="p-12 text-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-whatsapp mx-auto"></div>
            <p className="text-gray-500 mt-4">{t('common.loading')}</p>
          </div>
        ) : messages.length === 0 ? (
          <div className="p-12 text-center text-gray-500">
            <p className="text-lg mb-2">{t('hist.empty')}</p>
            <p className="text-sm">{t('hist.emptyHint')}</p>
          </div>
        ) : (
          <>
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-100 bg-gray-50">
                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">{t('hist.recipient')}</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">{t('hist.template')}</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">{t('hist.status')}</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">{t('hist.date')}</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">{t('hist.messageId')}</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {messages.map(msg => (
                  <tr key={msg.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 text-sm font-medium text-gray-900">{msg.recipientPhone}</td>
                    <td className="px-6 py-4 text-sm text-gray-600">{msg.templateName}</td>
                    <td className="px-6 py-4">{getStatusBadge(msg.status)}</td>
                    <td className="px-6 py-4 text-sm text-gray-500">{new Date(msg.createdAt).toLocaleString("pt-BR")}</td>
                    <td className="px-6 py-4 text-xs font-mono text-gray-400 truncate max-w-[200px]">{msg.messageId || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Paginacao */}
            {pagination.pages > 1 && (
              <div className="flex items-center justify-between px-6 py-4 border-t border-gray-100">
                <p className="text-sm text-gray-500">
                  Pagina {pagination.page} de {pagination.pages}
                </p>
                <div className="flex gap-2">
                  <button
                    onClick={() => loadMessages(pagination.page - 1)}
                    disabled={pagination.page <= 1}
                    className="px-4 py-2 text-sm font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  >
                    Anterior
                  </button>
                  <button
                    onClick={() => loadMessages(pagination.page + 1)}
                    disabled={pagination.page >= pagination.pages}
                    className="px-4 py-2 text-sm font-medium text-white bg-whatsapp rounded-lg hover:bg-whatsapp-dark disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  >
                    Proxima
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default History;
